function Info({text}) {
    return (
        <div style={{width: '100%', height: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text)'}}>
            {text}
        </div>
    )
}

export default Info;